const SELECTORS = {
    PICTURE: '.js-lazy-picture',
    SOURCE: '.js-lazy-source',
    IMAGE: '.js-lazy-img',
};

const MODIFIER = 'lazy-picture--loaded';

function lazyLoadImages() {
    const pictureNodes = [...document.querySelectorAll(SELECTORS.PICTURE)];
    const observer = new IntersectionObserver((entries, self) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                lazyLoad(entry.target);
                self.unobserve(entry.target);
            }
        });
    });

    if (pictureNodes) {
        pictureNodes.forEach((node) => {
            const img = node.querySelector(SELECTORS.IMAGE);
            const width = img.hasAttribute('width') ? parseInt(img.getAttribute('width'), 10) : 1;
            const height = img.hasAttribute('height') ? parseInt(img.getAttribute('height'), 10) : 1;

            img.style.aspectRatio = `${width / height}`;
            observer.observe(node);
        });
    }
}

function lazyLoad(target) {
    const source = target.querySelector(SELECTORS.SOURCE);
    const img = target.querySelector(SELECTORS.IMAGE);

    source.srcset = source.dataset.srcset;
    img.src = img.dataset.src;
    img.style.aspectRatio = null;
    target.classList.add(MODIFIER);
}

export { lazyLoadImages };
